export default "__VITE_ASSET__BpQpivQE__"